import { createSlice } from "@reduxjs/toolkit";
import {
  deleteDonorCategory,
  getDonorCategory,
  undoDeleteDonorCategory,
} from "./Donor.api";

const donorCategorySlice = createSlice({
  name: "donorCategory",
  initialState: {
    donorCategory: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDonorCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDonorCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.donorCategory = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getDonorCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteDonorCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteDonorCategory.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.donorCategory.data) {
        state.donorCategory.data = state.donorCategory.data.filter(
          (donorCategory) => {
            return donorCategory._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.donorCategory.data is not an array:",
          state.donorCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteDonorCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteDonorCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteDonorCategory.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.donorCategory.data) {
        state.donorCategory.data = state.donorCategory.data.filter(
          (donorCategory) => {
            return donorCategory._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.donorCategory.data is not an array:",
          state.donorCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteDonorCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = donorCategorySlice.actions;
export default donorCategorySlice.reducer;
